// src/components/AssignNutritionModal.js
import React, { useState, useEffect } from 'react';
import api from '../api';
import { IoClose } from 'react-icons/io5';
import { toast } from 'react-hot-toast';

const AssignNutritionModal = ({ client, onClose, onAssigned }) => {
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await api.get('/nutrition-plans');
        setPlans(response.data);
      } catch (err) {
        setError('No se pudieron cargar los planes de nutrición.');
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedPlanId || !startDate) {
      setError('Selecciona un plan y una fecha de inicio.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await api.post(`/admin/clients/${client.id}/assign-nutrition`, {
        plan_id: parseInt(selectedPlanId),
        start_date: startDate,
      });
      toast.success('Plan de nutricion asignado con exito.');
      onAssigned();
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al asignar el plan.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex justify-center items-center z-50 p-4">
      <div className="glass-panel rounded-xl shadow-2xl w-full max-w-md animate-fade-up">
        <div className="flex justify-between items-center p-5 border-b border-gray-700/80">
          <h2 className="text-xl font-bold text-white">Asignar Plan de Nutrición</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white"><IoClose size={24} /></button>
        </div>

        <div className="p-5">
          {loading && <p className="text-gray-400 text-center py-4">Cargando planes...</p>}
          {!loading && (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && <p className="bg-red-950/50 border border-red-700 text-red-200 text-sm px-4 py-2 rounded-lg">{error}</p>}

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">Plan de Nutrición</label>
                {plans.length === 0 ? (
                  <p className="text-yellow-400 text-sm">No tienes planes de nutrición creados.</p>
                ) : (
                  <select
                    value={selectedPlanId}
                    onChange={(e) => setSelectedPlanId(e.target.value)}
                    required
                    className="w-full p-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none focus:border-marizan-red"
                  >
                    <option value="">Selecciona un plan...</option>
                    {plans.map((p) => (
                      <option key={p.id} value={p.id}>{p.name}</option>
                    ))}
                  </select>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-1">Fecha de Inicio</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  required
                  className="w-full p-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:outline-none focus:border-marizan-red"
                />
              </div>

              <div className="flex gap-3 pt-2">
                <button type="button" onClick={onClose} className="flex-1 bg-gray-700 hover:bg-gray-600 text-white font-semibold py-2 rounded-lg">Cancelar</button>
                <button type="submit" disabled={saving || plans.length === 0} className="flex-1 bg-marizan-red hover:bg-red-700 disabled:opacity-50 text-white font-bold py-2 rounded-lg">
                  {saving ? 'Asignando...' : 'Asignar Plan'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignNutritionModal;
